.hints {
  display: flex;
  flex-direction: column;
  padding-top: .7rem;
  margin-left: .75rem;
}

.hint {
  display: flex;
  align-items: center;
}

.hint > span {
  font-size: .7rem;
  color: var(--gray-alt);
}

.icon {
  font-size: .7rem;
  margin-right: .2rem;
}

.default {
  color: var(--gray-alt);
}

.error {
  color: var(--danger);
}

.success {
  color: var(--success);
}
